import React from 'react';
import { ItemCard } from 'components';

const LoadingSymbolSpinner = () => (
    <div className={`col-12 text-center loader-container`}>
        <img
            className={`d-flex mx-auto`}
            src="//static.tradera.net/touchweb/static/fallback/item-card.gif"
        />
    </div>
);

const LoadingSymbolCards = ({ itemsPerPage }) => {
    const items = [];

    for (let i = 0; i < itemsPerPage; i++) {
        items.push(
            <ItemCard
                ready={false}
                key={i}
                lazy={{
                    offset: 100,
                    once: true,
                    height: 0
                }}
            />
        );
    }

    return (
        <div className={`bp layout-grid`}>
            <section className={`row product-recommendations `}>
                <div className="card-list col-12 px-2 mx-auto">{items}</div>
            </section>
        </div>
    );
};

export { LoadingSymbolSpinner, LoadingSymbolCards };



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/recommendations/recommendation-loading-spinners.jsx